import React from 'react';
import { Tooltip, Card, Button } from 'antd';
import IconButton from 'component/icon/iconButton';
import Icon from 'component/icon';

const TableFunction = (props) => {
    const { functions, icon } = props;

    return !!functions?.length && (
        <Tooltip
            destroyTooltipOnHide={{ keepParent: false }}
            trigger="click"
            placement="bottomRight"
            overlayClassName="table-tooltip"
            title={(
                <Card className="w-min" bodyStyle={{ padding: 4 }}>
                    {functions.map((item) => item.isShow !== false && (
                        <Button
                            key={item.title}
                            size="small"
                            className="w-full my-0.5 px-3 text-white bg-table-tab-selected"
                            onClick={item.onClick}
                        >
                            {item.title}
                        </Button>
                    ))}
                </Card>
            )}
        >
            <IconButton icon={icon || <Icon name="output" />} title="匯出" />
        </Tooltip>
    );
};

export default TableFunction;
